import React, { useEffect, useCallback } from "react";
import { Col, List, Row, Checkbox } from "antd";
import { checkHasScrolledToBottomOfElement, getGuidFirst8 } from "@/utils/utils";
import ShipmentRequirementsSummaryItem from "./ShipmentRequirementsSummaryItem";
import ShipmentTagsList from "./ShipmentTagsList";
const renderItemTitle = (shipmentData) => {
    const { id } = shipmentData;
    return (React.createElement(Row, { justify: "space-between" },
        React.createElement(Col, { flex: 1 },
            React.createElement("span", { style: { fontSize: 18, fontWeight: "bold" } }, `Shipment - ${getGuidFirst8(id)}`)),
        React.createElement(Col, { flex: 1 },
            React.createElement(ShipmentTagsList, { shipmentData: shipmentData }))));
};
const handleListScroll = (e, setHasScrolledToBottomOfRequirements) => {
    if (!setHasScrolledToBottomOfRequirements)
        return;
    const element = e.target;
    const scrolledToBottom = checkHasScrolledToBottomOfElement(element);
    if (scrolledToBottom) {
        setHasScrolledToBottomOfRequirements(true);
    }
};
const ShipmentRequirementsSummary = ({ shipmentsList, setHasScrolledToBottomOfRequirements, hasCheckedAllVehicles, setHasCheckedAllVehicles, }) => {
    const handleCheckedAllVehiclesChange = useCallback(event => {
        setHasCheckedAllVehicles(!hasCheckedAllVehicles);
        event?.preventDefault?.();
    }, [hasCheckedAllVehicles, setHasCheckedAllVehicles]);
    useEffect(() => {
        if (!setHasScrolledToBottomOfRequirements)
            return;
        // Check if we need to require user to scroll through summary again to ensure they view requirements for the newly selected shipments
        const element = document.querySelector(".shipment-requirements-list");
        const scrolledToBottom = checkHasScrolledToBottomOfElement(element);
        if (scrolledToBottom) {
            setHasScrolledToBottomOfRequirements(true);
            return;
        }
        setHasScrolledToBottomOfRequirements(false);
    });
    return (React.createElement(List, { className: "shipment-requirements-list", bordered: true, dataSource: [...shipmentsList, "checkAllVehicles"], rowKey: item => (item === "checkAllVehicles" ? item : item.id), style: { maxHeight: 520, overflowY: "auto" }, 
        // @ts-ignore it's not part of the defined List props but it's forwarded to the List wrapper component
        onScroll: (event) => handleListScroll(event, setHasScrolledToBottomOfRequirements), renderItem: item => item === "checkAllVehicles" ? (React.createElement("div", { style: {
                paddingLeft: "28px",
                paddingBottom: "28px",
                paddingTop: "12px",
                marginTop: "12px",
            }, onClick: handleCheckedAllVehiclesChange },
            React.createElement(Checkbox, { checked: hasCheckedAllVehicles, onChange: handleCheckedAllVehiclesChange },
                React.createElement("span", { onClick: handleCheckedAllVehiclesChange }, "I confirm that I meet the requirements to transport the selected units, and I have read all pickup and dropoff instructions.")))) : (React.createElement(List.Item, { style: { marginTop: 8, marginBottom: 8 } },
            React.createElement(List.Item.Meta, { title: renderItemTitle(item), description: React.createElement(ShipmentRequirementsSummaryItem, { shipmentData: item }) }))) }));
};
export default ShipmentRequirementsSummary;
